import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

/** Shown when a business link points at a place this site doesn't have. */
export default function BusinessNotFound() {
  const { t } = useLang();

  return (
    <div className="grid place-items-center text-center px-6 py-24">
      <div>
        <h1 className="text-[22px] font-black">{t("notFound.place")}</h1>
        <p className="text-[13px] text-[#6d6d6a] mt-2 max-w-[320px]">{t("notFound.placeBody")}</p>
        <Link to="/" className="text-[13px] font-bold underline mt-3 inline-block">
          {t("notFound.browse")}
        </Link>
      </div>
    </div>
  );
}